/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Filter_AllInputs */

const en_filter_all = /** @type {(inputs: Filter_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`All filters (${i?.count} active)`)
};

const de_filter_all = /** @type {(inputs: Filter_AllInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle Filter (${i?.count} aktiv)`)
};

/**
* | output |
* | --- |
* | "All filters ({count} active)" |
*
* @param {Filter_AllInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_all = /** @type {((inputs: Filter_AllInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_AllInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_all(inputs)
	return en_filter_all(inputs)
});